export var EVENTS = {
	TYPE_SELECTED: 'TYPE_SELECTED',
	TYPES_NOT_FOUND: 'TYPES_NOT_FOUND',
	TYPES_FOUND: 'TYPES_FOUND',
	CANCELLED: 'CANCELLED'
};